// ============================= DRAFT - NOT READY TO USE ====================================
import { Zone } from "types/fromDb/Zones/zone.d";
import { Project } from "types/fromDb/Projects/project.d";
import { Sheet } from "types/fromDb/Sheets/sheet.d";
import { AllotmentNode } from "types/noocoDbTypes";
import { ProjectsTypesNames } from "types/enums/TemplateTypeName";
import { AllotmentsIds, AllotmentsKeys } from "types/enums/AllotmentIds";
import { IndicatorIds } from "types/enums/IndicatorsIds";
import {
  ComputedProject,
  ProjectProjectSheet,
  ReducedAllotmentNode,
} from "types/noocoTypes";
import { AcvData, SheetAcvData } from "types/other/acvData";
import { DetailledSheet, ReeqSheet } from "types/other/projectZone";
import { WidgetData } from "types/other/pdfParsingData";

let colorsPalette = [
  "#D67E8E",
  "#D69954",
  "#5ED674",
  "#74B9D6",
  "#96FFE5",
  "#D68369",
  "#9E7ED6",
  "#D6D05E",
  "#68EDA6",
  "#CA8B84",
  "#6CCFFF",
  "#72E336",
  "#FFC400",
  "#D5BBFF",
  "#FFD5BB",
  "#FE80B1",
  "#CCCCCC",
  "#D15239",
  "#5689E5",
  "#8C8C8C",
  "#F7A19A",
  "#FFDAA2",
  "#C7A0CB",
  "#FDB94D",
  "#00B274",
  "#CE59C1",
  "#FFF685",
  "#AD9268",
];

const colorsPaletteLength = colorsPalette.length;

interface HistogramSheet extends Sheet {
  ProjectSheet: {
    ZoneId: string;
    AllotmentNodes: AllotmentNode[];
    quantity: number;
  };
  length?: number;
}

interface HistogramAllotmentNode extends AllotmentNode {
  AllotmentNodes: AllotmentNode[];
}

interface HistogramDataEquipmentDetails {
  AllotmentId: number;
  ParentId: number;
  id: number;
}

interface HistogramDataEquipment {
  sheets: HistogramSheet;
  [key: number]: number;
  0: number;
  details: AllotmentNode[];
  res: number;
}

interface HistogramProject extends Project {
  templateType: ProjectsTypesNames;
  isAcvDynamic: boolean;
  isStaticCarbon: boolean;
}

interface HistogramData {
  selectedZoneIdForGraph: string;
  parsedZones: CalculZone[];
  currentProject: HistogramProject;
  structureGraph: HistogramDataEquipment[];
  level: number;
  currentAllotment: HistogramAllotmentNode;
  project: HistogramProject;
  surfaceRef: number;
  sortedBy: string;
  selectedFilterLot: { id: number; label: string }[];
}

interface CalculZone extends Omit<Zone, "id" | "ParentId"> {
  id: string;
  ParentId: string;
}

interface IHistogram {
  process(): void;
}

export interface FormatedGraphData {
  name: string;
  [key: string]: string | number;
}

const compressData = (data: FormatedGraphData[], level: string) => {
  let newData = [];

  data = data.filter((el) => el);

  for (let i in data) {
    const index = parseInt(i);
    if (index === 9) {
      newData.push(data[index]);

      for (let k in newData[9]) {
        if (newData[9][k] === level) {
          newData[9][k] = "Autres";
        }
      }
    } else if (index > 9) {
      for (const [key, value] of Object.entries(data[index])) {
        newData[9][key] = value;
      }

      newData[newData.length - 1][level] = "Autres";
    } else {
      newData.push(data[index]);
    }
  }

  return newData;
};

export const addBuildingSiteIds = (
  selectedZoneId: string,
  parsedZones: CalculZone[],
  projectArea: number
) => {
  const isProjectSelected = selectedZoneId === "project";
  const isPlotSelected = parsedZones.find(
    (zone) => zone.type === "plot" && zone.id === selectedZoneId
  );
  let referenceArea: number | undefined =
    isProjectSelected || isPlotSelected ? projectArea : 0;
  let validZonesIds = isProjectSelected
    ? parsedZones.map((zone) => zone.id)
    : [selectedZoneId];

  validZonesIds = isPlotSelected
    ? validZonesIds.concat(
        parsedZones
          .filter(
            (zone) =>
              zone.type === "buildingSite" && zone.ParentId === selectedZoneId
          )
          .map((buildingZone) => buildingZone.id)
      )
    : validZonesIds;

  if (isProjectSelected || isPlotSelected) {
    return { validZonesIds, referenceArea };
  }

  let selectedZone = parsedZones.find((zone) => zone.id === selectedZoneId);

  referenceArea = selectedZone?.area;

  let childSelectedZonesIds = [selectedZoneId];
  let parentZoneIds = [selectedZoneId];

  while (childSelectedZonesIds.length > 0) {
    childSelectedZonesIds = parsedZones
      .filter((zone) => parentZoneIds.includes(zone.ParentId))
      .map((childZone) => childZone.id);
    parentZoneIds = childSelectedZonesIds;

    validZonesIds = validZonesIds.concat(childSelectedZonesIds);
  }

  return { validZonesIds: Array.from(new Set(validZonesIds)), referenceArea };
};

export const computeResult = (
  quantity: number,
  refUnit: string,
  projectDdv: number,
  totalImpact: number,
  surfaceRef: number,
  sortedBy: string,
  optiDelta: number | null
) => {
  surfaceRef = refUnit === "total" ? 1 : surfaceRef;

  let result = totalImpact / surfaceRef;

  if (sortedBy === "potentiel" && optiDelta !== null) {
    result = (optiDelta * quantity * projectDdv) / 50 / surfaceRef;
  }

  return result;
};

export const getColorFromString = (str: string) => {
  let hash = 0;
  let sLength = str.length;

  if (sLength === 0) return hash;

  for (let index = 0; index < sLength; index += 1) {
    hash = str.charCodeAt(index) + ((hash << str.length) - hash);

    hash = hash & hash;
  }

  hash =
    ((hash % colorsPaletteLength) + sLength + colorsPaletteLength) %
    colorsPaletteLength;

  return colorsPalette[hash];
};

function getTotalImpact(indicatorId: number, sheet: DetailledSheet) {
  let useStatic = false;

  if (indicatorId === IndicatorIds.STATIC) {
    useStatic = true;
    indicatorId = IndicatorIds.DYNAMIC;
  }

  const acvData: AcvData =
    useStatic || indicatorId !== IndicatorIds.DYNAMIC
      ? sheet.ACV[indicatorId].static
      : sheet.ACV[indicatorId].dynamic;

  return acvData.total + acvData.totalFluid;
}

function returnNodeForCertifiedAllotment(
  currentAllotmentId: number,
  noocoNode: AllotmentNode | ReducedAllotmentNode,
  allotmentNodesMap: Map<number, ReducedAllotmentNode>
): ReducedAllotmentNode {
  let currentAllotmentKey =
    currentAllotmentId === AllotmentsIds.RE2020
      ? AllotmentsKeys.RE2020
      : AllotmentsKeys.EPCM;

  let certifiedNode = allotmentNodesMap.get(noocoNode[currentAllotmentKey]!);

  return certifiedNode!;
}

function returnSheetForCertifiedAllotment(sheetNooco: DetailledSheet) {
  if (
    !sheetNooco.ReEqs ||
    !sheetNooco.ReEqs[0] ||
    sheetNooco.ReEqs[0].Re2020Id === sheetNooco.id
  ) {
    return sheetNooco;
  }
  return sheetNooco.ReEqs[0].Re2020 as DetailledSheet;
}

function returnParentNodeDependingOnAllotment(
  currentAllotmentId: number,
  currentNode: ReducedAllotmentNode,
  allotmentNodesMap: Map<number, ReducedAllotmentNode>
): ReducedAllotmentNode {
  if (currentAllotmentId === AllotmentsIds.NOOCO) {
    return allotmentNodesMap.get(currentNode.ParentId!)!;
  } else {
    return returnNodeForCertifiedAllotment(
      currentAllotmentId,
      currentNode,
      allotmentNodesMap
    );
  }
}

function aggregateGraphData(
  graphDataMap: Map<string, FormatedGraphData>,
  nodeFromProjectSheet: AllotmentNode | ReducedAllotmentNode,
  parentFromCurrentNode: ReducedAllotmentNode,
  result: number
) {
  const calculImpactForGraph = (data: FormatedGraphData) =>
    data[nodeFromProjectSheet.name] &&
    typeof data[nodeFromProjectSheet.name] === "number"
      ? (data[nodeFromProjectSheet.name] as number) + result
      : result;

  const returnColorAndIdRelatedToNode = (node: ReducedAllotmentNode) => ({
    [`${nodeFromProjectSheet.name}Color`]: getColorFromString(
      nodeFromProjectSheet.name
    ),
    [`${nodeFromProjectSheet.name}Id`]: nodeFromProjectSheet.id.toString(),
  });

  let nodeAlreadyInGraphData: FormatedGraphData | undefined = graphDataMap.get(
    parentFromCurrentNode.name
  );

  if (nodeAlreadyInGraphData) {
    graphDataMap.set(parentFromCurrentNode.name, {
      ...nodeAlreadyInGraphData,
      [nodeFromProjectSheet.name]: calculImpactForGraph(nodeAlreadyInGraphData),
      ...returnColorAndIdRelatedToNode(nodeFromProjectSheet),
    });
  } else {
    graphDataMap.set(parentFromCurrentNode.name, {
      name: parentFromCurrentNode.name,
      [nodeFromProjectSheet.name]: result,
      ...returnColorAndIdRelatedToNode(nodeFromProjectSheet),
    });
  }
}

function returnSheetDependingOnAllotment(
  currentAllotmentId: number,
  noocoSheet: DetailledSheet
) {
  if (currentAllotmentId === AllotmentsIds.NOOCO) {
    return noocoSheet;
  } else {
    return returnSheetForCertifiedAllotment(noocoSheet);
  }
}
export class Histogram implements IHistogram {
  constructor() {}
  process(): void {
    throw new Error("Method not implemented.");
  }

  processDataGraph(
    indicatorId: number,
    allotmentNodesMap: Map<number, ReducedAllotmentNode>,
    allProjectSheets: ProjectProjectSheet[],
    currentProject: ComputedProject,
    widgetData: WidgetData
  ) {
    let graphDataMap: Map<string, FormatedGraphData> = new Map();
    let graphKeys: string[] = [];
    let totalImpactDepandingOnRefUnit: number = 0;
    allProjectSheets.forEach((projectSheet: ProjectProjectSheet) => {
      let nodeFromProjectSheet: AllotmentNode | ReducedAllotmentNode =
        projectSheet.AllotmentNodes.find(
          (node: AllotmentNode) => node.AllotmentId === AllotmentsIds.NOOCO
        ) as AllotmentNode | ReducedAllotmentNode;

      if (nodeFromProjectSheet) {
        let sheetDepandingOnAllotment: DetailledSheet =
          returnSheetDependingOnAllotment(
            currentProject.ProjectOption.CurrentAllotmentId!,
            projectSheet.Sheet
          )!;

        let parentFromCurrentNode: ReducedAllotmentNode =
          returnParentNodeDependingOnAllotment(
            currentProject.ProjectOption.CurrentAllotmentId!,
            nodeFromProjectSheet,
            allotmentNodesMap!
          );

        if (!graphKeys.includes(nodeFromProjectSheet.name)) {
          graphKeys.push(nodeFromProjectSheet.name);
        }

        let totalImpactForSheet = getTotalImpact(
          indicatorId,
          sheetDepandingOnAllotment
        );

        const unitImpact = computeResult(
          projectSheet.quantity,
          currentProject.refUnit,
          currentProject.ddv,
          totalImpactForSheet,
          currentProject.area,
          widgetData?.sortedBy,
          sheetDepandingOnAllotment.optiDelta
        );

        totalImpactDepandingOnRefUnit += unitImpact;

        aggregateGraphData(
          graphDataMap,
          nodeFromProjectSheet,
          parentFromCurrentNode,
          unitImpact
        );
      }
    });

    let graphData: FormatedGraphData[] = Array.from(graphDataMap.values());

    graphData = compressData(
      graphData.sort(function (a, b) {
        let aSum = 0;
        let bSum = 0;

        for (let i in a) {
          if (typeof a[i] === "number") {
            aSum += a[i] as number;
          }
        }

        for (let j in b) {
          if (typeof b[j] === "number") {
            bSum += b[j] as number;
          }
        }

        return bSum - aSum;
      }),
      "name"
    );

    return {
      graphData: graphData,
      graphKeys: graphKeys,
      impactTotal: totalImpactDepandingOnRefUnit,
    };
  }
}
